var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c("div", { staticClass: "nav-title" }, [
      _c("img", {
        staticClass: "nav-logo",
        attrs: { src: require("@/assets/layaair-logo-black.png"), alt: "" },
        on: { click: _vm.goHome },
      }),
    ]),
    _c(
      "div",
      { staticClass: "right-menu" },
      [
        _c("span", { staticClass: "username" }, [
          _vm._v(
            _vm._s(_vm.name) + " (" + _vm._s(_vm.loginData.developer_uid) + ")"
          ),
        ]),
        _c(
          "el-dropdown",
          { staticClass: "avatar-container" },
          [
            _c(
              "div",
              {
                staticClass: "avatar-wrapper",
                staticStyle: { "margin-right": "20px" },
              },
              [
                _c("div", { staticClass: "user-avatar" }, [
                  _vm._v(
                    _vm._s(_vm.loginData.nickname.substr(0, 1).toUpperCase())
                  ),
                ]),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]
            ),
            _c(
              "el-dropdown-menu",
              {
                staticClass: "user-dropdown",
                attrs: { slot: "dropdown" },
                slot: "dropdown",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "User" } } },
                  [_c("el-dropdown-item", [_vm._v("个人中心")])],
                  1
                ),
                _c("el-dropdown-item", [
                  _c(
                    "span",
                    {
                      staticStyle: { display: "block" },
                      on: { click: _vm.logout },
                    },
                    [_vm._v("退出")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }